<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <div class="logo">
        <img :src="require('@/assets/Logo.svg')" alt="Logo" />
      </div>
      <hr class="horizontal-line" />
      <ul class="menu-list">
        <li :class="{ active: isActiveRoute('/dashboard') }">
          <router-link to="/dashboard">
            <img
              :src="require('@/assets/main.svg')"
              alt="create"
              class="sidebar-icon"
            />
            <span>Главная</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/create-agent'), disabled: true }">
          <router-link to="#" @click.prevent>
            <img
              :src="require('@/assets/add_square.svg')"
              alt="create"
              class="sidebar-icon"
            />
            <span>Создать агента</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/my-agents'), disabled: true }">
          <router-link to="#" @click.prevent>
            <img
              :src="require('@/assets/users.svg')"
              alt="agents"
              class="sidebar-icon"
            />
            <span>Мои агенты</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/conversations') }">
          <router-link to="/conversations">
            <img
              :src="require('@/assets/chat.svg')"
              alt="chat"
              class="sidebar-icon"
            />
            <span>Разговоры</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/business'), disabled: true }">
          <router-link to="#" @click.prevent>
            <img
              :src="require('@/assets/business.svg')"
              alt="case"
              class="sidebar-icon"
            />
            <span>Бизнес</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/pricing'), disabled: true }">
          <router-link to="#" @click.prevent>
            <img
              :src="require('@/assets/card.svg')"
              alt="pricing"
              class="sidebar-icon"
            />
            <span>Тарифы</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/settings'), disabled: true }" style="margin-top: 32px;">
          <router-link to="/settings">
            <img
              :src="require('@/assets/settings.svg')"
              alt="settings"
              class="sidebar-icon"
            />
            <span>Настройки</span>
          </router-link>
        </li>
        <li :class="{ active: isActiveRoute('/support') }" style="margin-top: 0px;">
          <a href="mailto:david@syncallai.com">
            <img
              :src="require('@/assets/support.svg')"
              alt="help"
              class="sidebar-icon"
            />
            <span>Поддержка</span>
          </a>
        </li>
      </ul>

      <div class="user-profile">
        <hr class="horizontal-line-with-padding" />
        <p class="profile-name">
          {{ name }}
          <span class="exit-icon" @click="logout">
            <img :src="require('@/assets/exit.svg')" alt="exit" />
          </span>
        </p>
        <p class="profile-email">{{ email }}</p>
        <p class="profile-tariff">Тариф: {{ 0  }} $/мин</p>
      </div>
    </div>
    <div class="vertical-line"></div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useMainStore } from '@/stores/mainStore'; // Import the Pinia store
import { useRoute } from 'vue-router';

export default {
  name: "AppSidebar",
  setup() {
    const store = useMainStore(); // Initialize the store
    const email = ref(""); // Local state for email
    const name = ref(""); // Local state for name
    const route = useRoute();

    const fetchUserInfo = async () => {
      // Use mock data instead of API requests
      email.value = "balticai@gmail.com";
      store.setTariffPlan(0.05);
      name.value = "Baltic AI";
    };

    onMounted(() => {
      fetchUserInfo(); // Fetch user info when the component is mounted
    });

    const logout = () => {
      localStorage.removeItem("token");
      window.location.href = "/login"; // Redirect to login
    };

    const isActiveRoute = (path) => {
      return route.path.startsWith(path);
    };


    console.log(window.location.pathname);

    return {
      email,
      name,
      logout,
      isActiveRoute,
      store, 
    };
  },
};
</script>


<style scoped>
.sidebar-wrapper {
  display: flex;
  height: 100vh; /* Full height of the viewport */
  width: 100%; /* Full width of the viewport */
}

.sidebar {
  position: fixed;
  width: 250px;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  left: 0;
  z-index: 1000;
}

.vertical-line {
  position: fixed;
  left: 250px; /* Align it next to the sidebar */
  height: 100vh;
  width: 1px;
  background-color: #f3f3f3; /* You can set the color as needed */
}

img.sidebar-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.logo img {
  width: 150px;
  padding-left: 18px;
  padding-top: 32px;
}

.horizontal-line {
  margin: 10px 0;
  border: none;
  border-top: 1px solid #f3f3f3;
}

.horizontal-line-with-padding {
  margin-left: 20px;
  margin-right: 20px;
  border: none;
  border-top: 1px solid #f3f3f3;
}

.menu-list {
  list-style: none;
  padding-left: 28px;
  margin: 0;
  height: 100%;
}

.menu-list li {
  margin: 12px 8px 0px 0px;
  padding: 12px 8px;
  border-radius: 10px;
}

.menu-list li a {
  text-decoration: none;
  color: #000;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.menu-list li a i {
  margin-right: 10px;
}

.menu-list-bottom {
  list-style: none;
  padding-left: 28px;
  margin-top: auto;
}

.menu-list-bottom li {
  margin: 12px 0;
}

.menu-list-bottom li a {
  text-decoration: none;
  color: #000;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.menu-list-bottom li a i {
  margin-right: 10px;
}

.user-profile {
  text-align: start;
  margin-left: 16px;
  margin-bottom: 32px;
}

.profile-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin: 0;
  margin-top: 24px;
  font-weight: 600;
}

.exit-icon {
  margin-right: 24px;
  cursor: pointer;
}

.exit-icon img {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.exit-icon img:hover {
  transform: scale(1.1);
}

.profile-email {
  font-weight: normal;
  font-size: 14px;
  margin-top: 0;
}

.active {
  font-weight: bold;
  background-color: #c6f432; /* Optional background color */
  border-radius: 8px;
}

.profile-tariff {
  font-size: 10px;
  margin-top: 8px;
}

.disabled {
  color: gray;
  pointer-events: none; /* Disable clicks */
  cursor: not-allowed; 
}
.disabled a{
  color: gray !important;
  cursor: not-allowed !important;
}

.disabled .sidebar-icon {
  opacity: 0.5; /* Gray out icons */
} 
</style>
